import { createContext } from 'react';

export const LinesContext = createContext<{
  enableLines: boolean
}>({
  enableLines: false,
});
